import uuidv4 from 'uuid/v4';

import { dispatchPromise, fetchResources } from './action-helpers';

import { getCurrentUserId } from '../services/store-service';

const DEFAULT_TIME_ENTRY_PROPS = {
    id: null,
    user: null,
    project: undefined,
    task: undefined,
    start: null
};

export const startTimeEntry = timeEntryProps => {
    return dispatchPromise({
        type: 'TIME_ENTRY_START_REQUESTED',
        payload: {
            timeEntry: Object.assign({}, DEFAULT_TIME_ENTRY_PROPS, timeEntryProps, {
                id: uuidv4(),
                user: getCurrentUserId(),
                start: new Date().getTime()
            })
        }
    });
}

export const fetchTimeEntries = (fetchProps, all) => fetchResources('TIME_ENTRIES_FETCH_REQUESTED', fetchProps, all);

export const fetchTimeEntry = timeEntryId => {
    return dispatchPromise({
        type: 'TIME_ENTRY_FETCH_REQUESTED',
        payload: { timeEntryId }
    });
}

export const stopTimeEntry = timeEntryId => {
    return dispatchPromise({
        type: 'TIME_ENTRY_STOP_REQUESTED',
        payload: { timeEntryId }
    });
}

export const updateTimeEntry = (timeEntryId, timeEntryProps, preventSave) => {
    return dispatchPromise({
        type: 'TIME_ENTRY_UPDATE_REQUESTED',
        preventSave,
        payload: {
            timeEntryId,
            timeEntryProps
        }
    });
}

export const removeTimeEntry = timeEntryId => {
    return dispatchPromise({
        type: 'TIME_ENTRY_REMOVE_REQUESTED',
        payload: {
            timeEntryId
        }
    });
}
